import React from 'react';

const Screenshot = () => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5625 24.1875H3.8125C3.26022 24.1875 2.8125 23.7398 2.8125 23.1875V17.4375"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M24.1875 9.56249V3.75624C24.1875 3.20396 23.7398 2.75624 23.1875 2.75624H17.4375"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M2.8125 9.56249V3.75624C2.8125 3.20396 3.26022 2.75624 3.8125 2.75624H9.5625"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M17.4375 24.1875H23.1875C23.7398 24.1875 24.1875 23.7398 24.1875 23.1875V17.4375"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);

export default Screenshot;
